import {StyleSheet} from 'react-native';

import {white} from '/theme/color/on.color';
import {alto, codGray} from '/theme/color/secondary.color';

export default StyleSheet.create({
  ffTeamsOrgSrContainer: {
    backgroundColor: white,
    paddingVertical: 8,
  },
  container: {
    height: 120,
    borderTopWidth: 1,
    borderColor: alto,
    backgroundColor: white,
  },
  ffTeamsOrgSrButton: {
    height: 40,
    borderColor: alto,
    borderRadius: 8,
    backgroundColor: white,
    justifyContent: 'center',
    borderWidth: 1,
    paddingHorizontal: 12,
    alignSelf: 'flex-end',
  },
  button: {
    height: 40,
    borderColor: alto,
    borderRadius: 8,
    backgroundColor: white,
    justifyContent: 'center',
    borderWidth: 1,
    marginHorizontal: 50,
    marginTop: 25,
  },
  buttonStyle: {
    flexDirection: 'row',
  },
  ffTeamsOrgSrButtonText: {
    color: codGray,
    fontSize: 14,
    textAlign: 'center',
  },
  buttonText: {
    color: codGray,
    fontSize: 14,
    textAlign: 'center',
    flex: 1,
  },
  disabled: {
    opacity: 0.5,
  },
});
